// Service worker cleanup (disable caching to avoid white-screen from stale bundles).
if ("serviceWorker" in navigator && "caches" in window) {
  const disableSw = async () => {
    try {
      const regs = await navigator.serviceWorker.getRegistrations();
      await Promise.all(regs.map((r) => r.unregister()));
    } catch (e) {
      console.warn("sw unregister failed", e);
    }
    try {
      const keys = await caches.keys();
      await Promise.all(keys.filter((k) => k.startsWith("swk-")).map((k) => caches.delete(k)));
    } catch (e) {
      console.warn("sw cache cleanup failed", e);
    }
  };
  window.addEventListener("load", () => {
    disableSw().catch(() => undefined);
  });
}
